import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { IAdvancedRichText } from '../../../../../../inputs';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';

const LabelLikeFormItemWrapper = styled.div`
  position: relative;
  /* padding-top: 8px; */
`;
const LabelLikeFormItemLabel = styled.span`
  position: absolute;
  z-index: 2;
  padding: 0;
  right: 8px;
  left: 8px;
  margin-top: -9px;
  height: 18px;
  pointer-events: none;
  > span {
    font-size: 12px;
    padding: 0 4px;
    background-color: #fff;
    color: ${props => props.theme.colorText};
    pointer-events: visible;

    // Text ellipsis overflow
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &.required {
      &::before {
        content: '*' / ' ';
        display: inline-block;
        margin-inline-end: 0.1em;
        color: ${props => props.theme.colorError};
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
      }
    }
  }
`;

export interface ILabelLikeFormItemProps {
  label?: IAdvancedRichText;
  required?: boolean;
}
/**
 * Label
 */
export function LabelLikeFormItem(props: ILabelLikeFormItemProps) {
  const { label, required } = props;

  return (
    <LabelLikeFormItemWrapper>
      <LabelLikeFormItemLabel>
        <span className={clx({ required })}>
          <RichTextAdvancedRender hasCustomFont text={label} />
        </span>
      </LabelLikeFormItemLabel>
    </LabelLikeFormItemWrapper>
  );
}
